/* Shrivaa Theme JS v3.2 */

// ── HELPERS ──────────────────────────────────────────────────────────
function formatMoney(cents) {
  return '₹' + (cents / 100).toLocaleString('en-IN');
}

// ── TOAST ────────────────────────────────────────────────────────────
function showToast(msg) {
  const existing = document.querySelector('.cart-toast');
  if (existing) existing.remove();
  const t = document.createElement('div');
  t.className = 'cart-toast';
  t.textContent = msg;
  document.body.appendChild(t);
  setTimeout(() => t.classList.add('show'), 10);
  setTimeout(() => { t.classList.remove('show'); setTimeout(() => t.remove(), 300); }, 2500);
}

// ── CART COUNT ───────────────────────────────────────────────────────
function updateCartCount() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = cart.item_count > 0 ? cart.item_count : '';
      });
      updateFloatingCart(cart);
    });
}

// ── FLOATING CART ────────────────────────────────────────────────────
function updateFloatingCart(cart) {
  if (!cart) {
    fetch('/cart.js').then(r => r.json()).then(c => updateFloatingCart(c));
    return;
  }
  const btn = document.querySelector('.floating-cart');
  const label = document.querySelector('.floating-cart__label');
  const count = document.querySelector('.floating-cart__count');
  if (!btn || !label) return;
  if (cart.item_count > 0) {
    btn.href = '/cart';
    label.textContent = 'Buy Now';
    if (count) { count.textContent = cart.item_count; count.style.display = 'flex'; }
  } else {
    btn.href = '/collections/all';
    label.textContent = 'Buy';
    if (count) count.style.display = 'none';
  }
}

// ── ADD TO CART ──────────────────────────────────────────────────────
function addToCart(variantId, qty) {
  qty = qty || 1;
  if (!variantId) { showToast('Please select a size'); return; }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({ id: parseInt(variantId), quantity: qty })
  })
  .then(r => r.json())
  .then(item => {
    if (item.status === 422 || item.status === 404) {
      showToast(item.description || 'Could not add to cart');
      return;
    }
    updateCartCount();
    showToast((item.product_title || 'Item') + ' added ✓');
    if (window.location.pathname === '/cart') {
      setTimeout(() => location.reload(), 800);
    }
  })
  .catch(() => showToast('Something went wrong — please try again'));
}

// ── CART UPDATE (qty / remove) ───────────────────────────────────────
function cartUpdate(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(r => r.json())
  .then(cart => {
    if (cart.item_count === 0) {
      setTimeout(() => location.reload(), 300);
      return;
    }
    if (window.location.pathname === '/cart') {
      setTimeout(() => location.reload(), 500);
      return;
    }
    updateCartCount();
    const subtotalEl = document.getElementById('cart-subtotal');
    const totalEl = document.getElementById('cart-total');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    cart.items.forEach(item => {
      const row = document.querySelector('.cart-item[data-key="' + item.key + '"]');
      if (!row) return;
      const minusBtn = row.querySelector('.qty-minus');
      const plusBtn = row.querySelector('.qty-plus');
      const qtyDisplay = row.querySelector('.qty-display');
      const priceEl = row.querySelector('.cart-item__price');
      if (minusBtn) minusBtn.dataset.qty = Math.max(0, item.quantity - 1);
      if (plusBtn) plusBtn.dataset.qty = item.quantity + 1;
      if (qtyDisplay) qtyDisplay.textContent = item.quantity;
      if (priceEl) priceEl.textContent = formatMoney(item.final_line_price);
    });
    document.querySelectorAll('.cart-item[data-key]').forEach(row => {
      const stillInCart = cart.items.find(i => i.key === row.dataset.key);
      if (!stillInCart) row.remove();
    });
  })
  .catch(() => showToast('Something went wrong'));
}

// ── SEARCH OVERLAY ───────────────────────────────────────────────────
function initSearch() {
  const overlay = document.getElementById('search-overlay');
  const openBtn = document.querySelector('.site-header__search-btn');
  const closeBtn = document.querySelector('.search-overlay__close');
  const input = document.querySelector('.search-overlay__input');
  if (!overlay) return;
  openBtn?.addEventListener('click', () => {
    overlay.classList.add('open');
    setTimeout(() => input?.focus(), 100);
  });
  closeBtn?.addEventListener('click', () => overlay.classList.remove('open'));
  overlay.addEventListener('click', e => {
    if (e.target === overlay) overlay.classList.remove('open');
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') overlay.classList.remove('open');
  });
}

// ── MOBILE MENU ──────────────────────────────────────────────────────
function initMobileMenu() {
  const btn = document.querySelector('.mobile-menu-btn');
  const nav = document.querySelector('.mobile-nav');
  if (!btn || !nav) return;
  btn.addEventListener('click', () => {
    nav.classList.toggle('open');
    btn.setAttribute('aria-expanded', nav.classList.contains('open'));
  });
}

// ── PRODUCT GALLERY ──────────────────────────────────────────────────
function initGallery() {
  const thumbs = document.querySelectorAll('.product-page__thumb');
  const mainImg = document.querySelector('.product-page__main-img img');
  if (!thumbs.length || !mainImg) return;
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (thumb.dataset.src) mainImg.src = thumb.dataset.src;
    });
  });
  if (thumbs[0]) thumbs[0].classList.add('active');
}

// ── VARIANT SELECTOR ─────────────────────────────────────────────────
function initVariants() {
  const btns = document.querySelectorAll('.variant-btn');
  const priceEl = document.getElementById('product-price');
  const atcBtn = document.getElementById('atc-btn');
  const stockEl = document.getElementById('stock-status');
  btns.forEach(btn => {
    btn.addEventListener('click', () => {
      btns.forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');
      if (priceEl && btn.dataset.price) priceEl.innerHTML = btn.dataset.price;
      if (atcBtn) atcBtn.dataset.variantId = btn.dataset.variantId;
      if (stockEl && btn.dataset.available !== undefined) {
        const avail = btn.dataset.available === 'true';
        const qty = parseInt(btn.dataset.qty || '99');
        if (!avail) {
          stockEl.textContent = 'Out of stock';
          stockEl.className = 'product-page__stock product-page__stock--out';
          if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Out of Stock'; }
        } else if (qty <= 5) {
          stockEl.textContent = 'Only ' + qty + ' left';
          stockEl.className = 'product-page__stock product-page__stock--low';
          if (atcBtn) { atcBtn.disabled = false; atcBtn.textContent = 'Add to Cart'; }
        } else {
          stockEl.textContent = 'In stock';
          stockEl.className = 'product-page__stock product-page__stock--in';
          if (atcBtn) { atcBtn.disabled = false; atcBtn.textContent = 'Add to Cart'; }
        }
      }
    });
  });
  if (btns[0]) btns[0].click();
}

// ── QTY SELECTOR (product page) ──────────────────────────────────────
function initQty() {
  let qty = 1;
  const display = document.getElementById('qty-display');
  document.getElementById('qty-minus')?.addEventListener('click', () => {
    qty = Math.max(1, qty - 1);
    if (display) display.textContent = qty;
  });
  document.getElementById('qty-plus')?.addEventListener('click', () => {
    qty++;
    if (display) display.textContent = qty;
  });
  document.getElementById('atc-btn')?.addEventListener('click', () => {
    const id = document.getElementById('atc-btn')?.dataset.variantId;
    addToCart(id, qty);
  });
  document.getElementById('buy-now-btn')?.addEventListener('click', () => {
    const id = document.getElementById('atc-btn')?.dataset.variantId;
    if (!id) return;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(id), quantity: qty })
    }).then(() => { window.location = '/checkout'; });
  });
}

// ── CART BUTTONS (cart page) ──────────────────────────────────────────
function initCartButtons() {
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      const key = this.dataset.key;
      const qty = parseInt(this.dataset.qty);
      cartUpdate(key, qty);
    });
  });
}

// ── SCROLL REVEAL ─────────────────────────────────────────────────────
const revealObs = new IntersectionObserver(entries => {
  entries.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('on'); revealObs.unobserve(e.target); }
  });
}, { threshold: 0.1 });

// ── INIT ──────────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  updateCartCount();
  initSearch();
  initMobileMenu();
  initGallery();
  initVariants();
  initQty();
  initCartButtons();
  document.querySelectorAll('.rv').forEach(el => revealObs.observe(el));
});